import { REQUEST_FEATURES, RECEIVE_FEATURES } from '../constants/actionTypes';
import { FEATURE_LIST } from '../constants/featureFlags';
import { FeatureState } from '../actions/feature/types/state';
import { ReceiveFeaturesAction, RequestFeaturesAction } from '../actions/featureActions';

type FeatureAction =
  | RequestFeaturesAction
  | ReceiveFeaturesAction
  | { type: string };

export const initialState: FeatureState = {
  isFetching: true,
  isLegacyFetching: true,
  isLaunchDarklyFetching: true,
  userConfigFeatures: FEATURE_LIST.reduce<Record<string, { value: boolean; source?: string }>>(
    (result, feature) => ({
      ...result,
      [feature]: {
        value: false,
      },
    }),
    {}
  ),
};

function featureReducer(
  state: FeatureState = initialState,
  action: FeatureAction
): FeatureState {
  switch (action.type) {
    case REQUEST_FEATURES:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_FEATURES: {
      const receiveAction = action as ReceiveFeaturesAction;
      const features = receiveAction.keys.reduce<Record<string, { value: boolean; source?: string }>>(
        (_features, key, index) => {
          const featureValue = receiveAction.values[index];
          const source =
            typeof featureValue === 'string'
              ? 'launchdarkly'
              : featureValue['source-key'] ?? 'launchdarkly';
          const value = typeof featureValue === 'string'
            ? featureValue
            : featureValue.value;

          return {
            ..._features,
            [key]: {
              source,
              value: String(value) === 'true',
            },
          };
        },
        {}
      );

      const isLegacyFetching =
        typeof receiveAction.legacy !== 'undefined' ? false : state.isLegacyFetching;
      const isLaunchDarklyFetching =
        typeof receiveAction.legacy === 'undefined'
          ? false
          : state.isLaunchDarklyFetching;

      return {
        ...state,
        isFetching: isLegacyFetching || isLaunchDarklyFetching,
        isLegacyFetching,
        isLaunchDarklyFetching,
        userConfigFeatures: {
          ...state.userConfigFeatures,
          ...features,
        },
      };
    }
    default:
      return state;
  }
}

export default featureReducer;
